import { DeviceTypes } from "../../config/documents/HardwareConfig";
import { PoolDeviceInterface, IOnoffable, IProbe } from "../Interfaces";
import PoolDeviceOnOffable from "./base-onoffable";
import Locale from "../../utils/Locale";
import { DisplayProcessingLogics, PoolDeviceCriticalDesiredActual } from "../Types";
import { safeJsonParse } from "../../utils/Json";

export enum criticalFieldIdentifiers {
    OnOff = "OnOff"
}

export default class PoolDeviceDissoolvedOxygenSensor extends PoolDeviceOnOffable implements PoolDeviceInterface, IOnoffable, IProbe {
    static CanBeAddedToflow = true;
    static DeviceType = DeviceTypes.DISSOLVEDOXYGENSENSOR;
    static Icon = "water-opacity";
    static minAutoFilterVersion = 39;
    static PickerTitle = Locale.gettext("Dissolved Oxygen Sensor");

    OnOffIdentifier = criticalFieldIdentifiers.OnOff;

    getCriticalFields(): PoolDeviceCriticalDesiredActual[] {
        let order = 0;
        const fields = [];

        {
            const DisplayName = Locale.gettext("Power");
            const common = {
                DisplayName, DisplayNameShort: DisplayName,
                DisplayOrder: ++order,
                DisplayProcessingLogic: DisplayProcessingLogics.ONOFF,
                DisplayProcessingLogicUnitAsDisplayName: false,
            };
            fields.push({
                Identifier: criticalFieldIdentifiers.OnOff,
                ActualProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.ActualPowerState }, common),
                DesiredProperty: Object.assign({ Name: PoolsideDaemonDeviceStateNames.PowerState }, common)
            });
        }

        return fields;
    }


    isCalibrated(): boolean {
        return this.getDeviceState(PoolsideDaemonDeviceStateNames.Calibrated)?.value > 0;
    }

    isReadyToCalibrate(): boolean {
        return !!this.getDeviceState(PoolsideDaemonDeviceStateNames.CalibrationReady)?.value;
    }

    getLastCalibrationTime(): Date | undefined {
        const stateValue = this.getDeviceState(PoolsideDaemonDeviceStateNames.LastCalibrationTime)?.value;
        if (stateValue) return new Date(safeJsonParse(stateValue));
    }
}

export enum PoolsideDaemonDeviceStateNames {
    ActualPowerState = "ActualPowerState",
    Calibrated = "Calibrated",
    CalibrationReady = "CalibrationReady",
    LastCalibrationTime = "LastCalibrationTime",
    PowerState = "PowerState",
}
